const isDevelopment = process.env.NODE_ENV === "development";

const emit = (level, args) => {
  if (!isDevelopment) {
    return;
  }
  const logger = typeof console !== "undefined" ? console[level] : undefined;
  if (typeof logger === "function") {
    logger.apply(console, args);
  }
};

export const logWarn = (...args) => emit("warn", args);

export const logError = (...args) => emit("error", args);
